import { Component, OnInit } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';

@Component({
  selector: 'app-legal-advice',
  templateUrl: './legal-advice.component.html',
  styleUrls: ['./legal-advice.component.scss']
})
export class LegalAdviceComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  catalogueProperties: any = {};

  constructor(private domService: DomService) { }

  ngOnInit() {
    


    this.domService.addClassToBody('bg-gray');
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
